import React from 'react';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';

import Icon from '../../../../../icons/Icon';

import scss from './FileChip.module.scss';

function FileChip({ onRemove, name, size }) {
  return (
    <div className={scss.chip} title={name}>
      <span className={scss.preview}>
        <Icon icon={InsertDriveFileOutlinedIcon} className={scss.fallbackIcon} />
      </span>

      <span className={scss.text}>
        <span className={scss.name}>{name}</span>
        {size ? <span className={scss.size}>{size}</span> : null}
      </span>

      <button type='button' className={scss.remove} onClick={onRemove} aria-label={`Remove ${name}`}>
        ×
      </button>
    </div>
  );
}

export default FileChip;
